import { SET_INCLUDE_CASH } from './constants';

const defaultState = {
    includeCash: true,
};

const cash = (state = defaultState, action) => {
    switch (action.type) {
        case SET_INCLUDE_CASH:
            return { ...state, includeCash: action.includeCash };

        default:
            return state;
    }
};

export default cash;



// WEBPACK FOOTER //
// ./src/containers/common/cash/reducer.js